import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const KycVerificationContext = createContext();

export function useKycVerificationContext() {
  return useContext(KycVerificationContext);
}

export function KycVerificationProvider(props) {
  const initForm = {
    cardNumber: "",
    mothersFirstName: "",
    mothersMiddleName: "",
    mothersLastName: "",
    dateOfBirth: "",
    emailAddress: "",
    placeOfBirth: "",
    mobileNumber: "",
    nationality: "",
    companyName: "",
    subdivision: "",
    selectedID: undefined,
    middleName: "",
    suffix: "",
    signature: undefined,
    firstName: "",
    areaCode: "",
    state: "",
    city: "",
    lastName: "",
    bldgName: "",
    idNumber: "",
    frontID: "",
    zipCode: "",
    selfie: "",
    backID: "",
    gender: "",
    street: "",
  };

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [hasUploadError, setHasUploadError] = useState(false);
  const [isTncAccepted, setIsTncAccepted] = useState(false);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [modalShown, setModalShown] = useState(false);
  const [formData, setFormData] = useState(initForm);
  const [currentStep, setCurrentStep] = useState(1);
  const [loadState, setLoadState] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const ios = /iphone|ipod|macintosh|ipad/.test(userAgent);
    const standalone = window.navigator.standalone;

    setIsMobile(ios || /android/.test(userAgent));
    setIsStandalone(standalone);
  }, []);

  const data = useMemo(
    () => ({
      setShowUploadModal,
      setHasUploadError,
      setIsTncAccepted,
      setIsCameraOpen,
      setErrorMessage,
      setCurrentStep,
      setModalShown,
      setLoadState,
      setFormData,
      navigate,
      isMobile,
      isStandalone,
      showUploadModal,
      hasUploadError,
      isTncAccepted,
      errorMessage,
      isCameraOpen,
      currentStep,
      modalShown,
      loadState,
      formData,
    }),
    [
      showUploadModal,
      hasUploadError,
      isTncAccepted,
      errorMessage,
      isMobile,
      isStandalone,
      isCameraOpen,
      currentStep,
      modalShown,
      loadState,
      formData,
    ]
  );

  return (
    <KycVerificationContext.Provider value={data}>
      {props.children}
    </KycVerificationContext.Provider>
  );
}

KycVerificationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
